import { ChangeDetectorRef, Component, Input, inject } from '@angular/core';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Commission } from 'src/model/commission.model';
import { CommissionService } from 'src/services/commission.service';
import { EditCommissionComponent } from '../edit-commission/edit-commission.component';

@Component({
    selector: 'app-previous-assigned-commission',
    templateUrl: './previous-assigned-commission.component.html',
    styleUrl: './previous-assigned-commission.component.scss',
    standalone: false
})
export class PreviousAssignedCommissionComponent {
  private sharedService = inject(SharedService);
  private cdr = inject(ChangeDetectorRef);
  private commissionService = inject(CommissionService);


  @Input() assignedCommisionList: Commission[] = [];
  isAssignedByLoggedInUser(commission: Commission) {
    const loggedInUsername = sessionStorage.getItem("username");
    if (loggedInUsername == commission.Assignor)
      return true;

    else
      return false;
  }


  confirmBeforeDeletingCommission(commission: Commission, commIndex: number) {
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = "Are you sure you want to delete the commission of " + commission.Assignee + "- RM " + commission.Amount + "?";

    modalRef.result.then((confirm) => {
      if (confirm)
        this.deleteCommission(commission.LoanId, commission.ID, commIndex);
    });
  }

  async deleteCommission(loanId: number, commissionId: number, commIndex: number) {

    const success = await this.commissionService.deleteCommission(commissionId, loanId);
    if (success == true) {
      //remove the commission from list
      this.assignedCommisionList.splice(commIndex, 1);

      this.cdr.detectChanges();
    }
  }

  openEditCommissionModal(commission: Commission) {
    const modalRef = this.sharedService.openModal(EditCommissionComponent);
    modalRef.componentInstance.amount = commission.Amount;
    modalRef.componentInstance.assignee = commission.Assignee;
    modalRef.componentInstance.loanId = commission.LoanId;
    modalRef.componentInstance.commissionId = commission.ID;

    modalRef.componentInstance.passEntry.subscribe((entry) => {
      window.location.reload();
    });
  }
}
